const ATTRIBUTION_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

function getCookie(name) {
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : ''
}

function attributionPayload() {
  const query = new URLSearchParams(window.location.search)

  return ATTRIBUTION_KEYS.reduce((payload, key) => {
    const value = query.get(key)
    if (value) payload[key] = value
    return payload
  }, {
    landing_url: window.location.href,
    referrer: document.referrer || '',
    ym_uid: getCookie('_ym_uid'),
    ym_sid: getCookie('_ym_sid')
  })
}

function showMessage(element, message, type) {
  element.textContent = message
  element.classList.remove('is-success', 'is-error')
  element.classList.add('is-visible', `is-${type}`)
}

async function submitLead(form) {
  const message = form.querySelector('[data-start-lead-message]')
  const button = form.querySelector('button[type="submit"]')
  const fields = new FormData(form)
  const name = String(fields.get('name') || '').trim()
  const email = String(fields.get('email') || '').trim()

  if (!name || !email) {
    showMessage(message, 'Укажите имя и email.', 'error')
    return
  }

  button.disabled = true
  const originalText = button.textContent
  button.textContent = 'Отправляем...'

  try {
    const response = await fetch('https://reg.place/mail', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Form-Source': 'start_landing'
      },
      credentials: 'include',
      body: JSON.stringify({
        mail_form: Object.assign({
          name: name,
          email: email,
          phone: String(fields.get('phone') || '').trim(),
          body: String(fields.get('body') || '').trim() || 'Заявка отправлена с лендинга Reg.place',
          source: 'start_landing',
          request_type: 'organiser'
        }, attributionPayload())
      })
    })

    if (!response.ok) throw new Error(`HTTP ${response.status}`)

    form.reset()
    showMessage(message, 'Спасибо! Мы свяжемся с вами в течение рабочего дня.', 'success')
    if (window.trackMetrikaGoal) window.trackMetrikaGoal('zayavka')
  } catch (_error) {
    showMessage(message, 'Не удалось отправить заявку. Попробуйте ещё раз или напишите на info@reg.place.', 'error')
  } finally {
    button.disabled = false
    button.textContent = originalText
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const leadSection = document.querySelector('.start-lead#start-lead-form')
  const form = leadSection && leadSection.querySelector('form.start-lead-form[data-start-lead-form]')
  if (!form) return

  form.addEventListener('submit', event => {
    event.preventDefault()
    submitLead(form)
  })
})
